import { useDataChange } from 'Simple/Data.js'
export function useOnClick(props) {
  let change = useDataChange({
    context: 'event_action',
    viewPath: props.viewPath,
  })
  return function onClick() {
    change(next => {
      next.data.create_task = false
      next.data.create_task_new = true
      next.data.actions = []
      next.data.new_task = {
        title: null,
        board_id: null,
        stage_id: null,
        actions: [],
        tags: [],
        ...next.data.new_task,
      }
    })
  }
}
